export const constant = {
	selector: {
		handler: 'data-m-tab',
		container: 'data-m-tab-container',
	},
}
